// Mirrors the roles in server/routes/konfipay-payments; the server enforces them.
export const REFUND_CREATE_ROLES = ["admin", "manager", "advanced_user", "buchhaltung"];
export const SYRINGES_REFUND_CREATE_ROLES = ["admin", "manager", "advanced_user"];
export const INVOICE_PAYMENT_ROLES = ["admin", "manager", "buchhaltung"];
export const MANUAL_CREATE_ROLES = ["admin", "manager", "advanced_user", "buchhaltung"];
export const PAYMENT_VIEW_ROLES = [...new Set([...REFUND_CREATE_ROLES, ...INVOICE_PAYMENT_ROLES])];
export const PAYMENT_ACCOUNTING_ROLES = ["admin", "manager", "buchhaltung"];

/** Abgebrochen, Bezahlt, Abgeschlossen, In Herstellung, Ware bestellt; the server checks them too. */
export const SYRINGES_REFUND_STATUS_IDS = [3, 6, 7, 8, 9];

export const SOURCE_LABELS = {
  refund: "Rückerstattung",
  syringes_refund: "Rückerstattung Abnehmspritzen",
  purchase_invoice: "Einkaufsrechnung",
  manual: "Manuelle Zahlung",
};

export const STATUS_LABELS = {
  draft: "Entwurf",
  created: "Angelegt",
  approved: "Freigegeben",
  submitted: "Eingereicht",
  failed: "Fehlgeschlagen",
  rejected: "Abgelehnt",
  deleted: "Gelöscht",
};

export const STATUS_BADGES = {
  draft: "badge-light",
  created: "badge-tertiary",
  approved: "badge-warning",
  submitted: "badge-success",
  failed: "badge-danger",
  rejected: "badge-danger",
  deleted: "badge-light",
};

/** Labels for `next_step`, which the server computes per order (including the 100 € rule). */
export const NEXT_STEP_LABELS = {
  konfipay: "Anlage in Konfipay fehlt",
  approval: "Freigabe fehlt",
  submit: "Übertragung fehlt",
  third_person_submit: "Übertragung durch zweite Prüfperson fehlt",
};

export const NEXT_STEP_BADGES = {
  konfipay: "badge-danger",
  approval: "badge-tertiary",
  submit: "badge-warning",
  third_person_submit: "badge-warning",
};

const DAYS_PATTERN = /(\d+)\s*(?:tage?|tagen)/i;

/** Due date from invoice date plus "N Tage" in the supplier's payment terms; never in the past. */
export function dueDateIso(invoiceDate, paymentTerms, today) {
  const match = DAYS_PATTERN.exec(paymentTerms || "");
  if (!invoiceDate || !match) return today;
  const due = new Date(`${invoiceDate}T00:00:00`);
  due.setDate(due.getDate() + Number(match[1]));
  const pad = (n) => String(n).padStart(2, "0");
  const iso = `${due.getFullYear()}-${pad(due.getMonth() + 1)}-${pad(due.getDate())}`;
  return iso < today ? today : iso;
}
